// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__3tayp","content":"Alert_content__3B4IT"};